<template>
  <div
    :class="$style.container"
    :style="bgImgUrl ? { backgroundImage: `url(${bgImgUrl})` } : undefined"
    :v-if="slides?.length"
  >
    <Slider1XP
      has-centered-slides
      has-multiple-slides-per-view
      :has-zoom="isDesktopOrWidescreen"
      is-rotating-carousel
      :should-loop="false"
      :space-between="isTabletOrMobile ? 16 : 32"
    >
      <CarouselSlide
        v-for="(slide, index) in slides"
        :key="index"
        :slide="slide"
        @open-modal="openModal"
      />
    </Slider1XP>
  </div>
  <Modal
    :is-modal-open="isModalOpen"
    :is-not-you-tube="!isYouTube"
    :is-video="true"
    @close-modal="closeModal"
  >
    <iframe
      v-if="isYouTube"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      :data-src="videoUrl"
      frameborder="0"
    />
    <video v-else ref="video" autoplay controls loop muted>
      <source :src="videoUrl" type="video/mp4" />
    </video>
  </Modal>
</template>
<script setup>
import Slider1XP from '../Slider1XP/Slider1XP.vue';
import { ref } from 'vue';
import Modal from '../Modal/Modal.vue';
import CarouselSlide from './CarouselSlide/CarouselSlide.vue';
import { isTabletOrMobile, isDesktopOrWidescreen } from '../../utils/breakpoints';

defineProps({
  uid: {
    type: String,
  },
  slides: {
    type: Array,
    default: () => [],
  },
  autoplay: {
    type: Boolean,
    default: false,
  },
  bgImgUrl: {
    type: String,
  },
  hidePagination: {
    type: Boolean,
    default: null,
  },
});

const isModalOpen = ref(false);
const isYouTube = ref(false);
const videoUrl = ref(null);
const video = ref(null);

const openModal = (slideVideo, slideIsYouTube) => {
  videoUrl.value = slideVideo;
  isYouTube.value = slideIsYouTube;
  isModalOpen.value = true;
  if (video.value !== null && !isYouTube.value) {
    video.value.load();
  }
};

const closeModal = () => {
  if (video.value !== null) {
    video.value.pause();
  }
  isModalOpen.value = false;
};
</script>

<style module lang="scss">
@forward './RotatingCarousel.scss';
</style>
